export default "__VITE_ASSET__DGwrnNk2__"